import { create } from "zustand";

export interface Mentoring {
  mentor_id: number;
  mentee_id: number;
  Status: string;
  Start_Date: string;
  End_Date: string;
}

export interface Mentor {
  id: string;
  name: string;
  email: string;
  profession: string[];
  dateAdded: string;
  lastConnected: string;
  image: string;
}

interface MentorStore {
  mentorings: Mentoring[];
  setMentorings: (mentorings: Mentoring[]) => void;
  deleteMentoring: (mentor_id: number) => void;
  addMentoring: (mentoring: Mentoring) => void; // New method to add a mentoring record
}

export const useMentoringStore = create<MentorStore>((set) => ({
  mentorings: [],
  setMentorings: (mentorings) => set({ mentorings }),
  deleteMentoring: (mentor_id) =>
    set((state) => ({
      mentorings: state.mentorings.filter(
        (m) => m.mentor_id !== mentor_id
      ),
    })),
  addMentoring: (mentoring) =>
    set((state) => ({
      mentorings: [...state.mentorings, mentoring], // Add the new mentoring entry
    })),
}));
